export const footerNavigationMock = [
  {
    label: 'About',
    url: '/about/',
    items: [
      {
        label: 'Our History',
        url: '/about/our-history/',
      },
      {
        label: 'Corporate',
        url: '/about/corporate/',
      },
      {
        label: 'Supporting the Community',
        url: '/about/supporting-the-community/',
      },
      {
        label: 'Museums of Auckland',
        url: 'https://museumsofauckland.com/',
      },
      {
        label: 'News',
        url: '/about/news/',
      },
    ],
  },
  {
    label: 'Contact Us',
    url: '/contact-us/',
    items: [
      {
        label: 'General Enquiries',
        url: '/contact-us/general-enquiries/',
      },
      {
        label: 'Education Bookings',
        url: '/contact-us/education-bookings/',
      },
      {
        label: 'Group Bookings',
        url: '/contact-us/group-bookings/',
      },
      {
        label: 'Private Events',
        url: '/contact-us/private-events/',
      },
      {
        label: 'Collection Offer',
        url: '/collections-and-stories/collection-offer/',
      },
      {
        label: 'Donate',
        url: '/support-and-join/donate/',
      },
    ],
  },
]
